import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { resetStyles } from '../../utils/ThemeUtil.js';
import { customElement } from '../../utils/WebComponentsUtil.js';
import '../wui-wallet-image/index.js';
import '../wui-icon-box/index.js';
import styles from './styles.js';
const TOTAL_IMAGES = 4;
let WuiAllWalletsImage = class WuiAllWalletsImage extends LitElement {
  constructor() {
    super(...arguments);
    this.walletImages = [];
  }
  render() {
    const isPlaceholders = this.walletImages.length < TOTAL_IMAGES;
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["", "\n      ", "\n      <wui-flex>\n        <wui-icon-box\n          size=\"xxs\"\n          iconSize=\"xxs\"\n          iconcolor=\"success-100\"\n          backgroundcolor=\"success-100\"\n          icon=\"checkmark\"\n          background=\"opaque\"\n        ></wui-icon-box>\n      </wui-flex>"])), this.walletImages.slice(0, TOTAL_IMAGES).map(_ref => {
      let {
        src,
        walletName
      } = _ref;
      return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            <wui-wallet-image\n              size=\"inherit\"\n              imageSrc=", "\n              name=", "\n            ></wui-wallet-image>\n          "])), src, ifDefined(walletName));
    }), isPlaceholders ? [...Array(TOTAL_IMAGES - this.walletImages.length)].map(() => html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([" <wui-wallet-image size=\"inherit\" name=\"\"></wui-wallet-image>"])))) : null);
  }
};
WuiAllWalletsImage.styles = [resetStyles, styles];
__decorate([property({
  type: Array
})], WuiAllWalletsImage.prototype, "walletImages", void 0);
WuiAllWalletsImage = __decorate([customElement('wui-all-wallets-image')], WuiAllWalletsImage);
export { WuiAllWalletsImage };
//# sourceMappingURL=index.js.map